import {
  OR_REQUEST_SUBSCRIPTION,
  OR_RECEIVE_SUBSCRIPTION,
  OR_RECEIVE_SUBSCRIPTION_ERROR,
} from '../../actions/management/orSubscription';
import {
  OR_BUILD_ORDER_PAYMENT_FAILED,
} from '../../actions/management/orOrders';

export const initialState = {
  data: {
    status: null,
    failedPayment: false,
    deliveryDay: null,
    frequency: null,
    deliveryTime: {},
    address: {},
    paymentToken: {
      type: null,
      expired: false, // Card only
      expirationDate: null, // Card only
      lastFourDigits: null, // Card only
      email: null, // PayPal only
    },
  },
  isFetchingORSubscription: false,
  isORSubscriptionError: false,
};

export default function orSubscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REQUEST_SUBSCRIPTION:
      return { ...state, isFetchingORSubscription: true };
    case OR_RECEIVE_SUBSCRIPTION: {
      const { data } = action;
      return {
        ...state,
        data: {
          status: data.status,
          failedPayment: data.failedPayment,
          deliveryDay: data.deliveryDay,
          frequency: data.frequency,
          deliveryTime: data.deliveryTime,
          address: data.address,
          paymentToken: data.paymentToken,
        },
        isFetchingORSubscription: false,
        isORSubscriptionError: false,
      };
    }
    case OR_RECEIVE_SUBSCRIPTION_ERROR:
      return {
        ...state,
        data: { ...initialState.data },
        isFetchingORSubscription: false,
        isORSubscriptionError: true,
      };
    case OR_BUILD_ORDER_PAYMENT_FAILED:
      return {
        ...state,
        data: {
          ...state.data,
          failedPayment: true,
        },
      };
    default:
      return state;
  }
}
